"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Healthcare = function Healthcare(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/applications/healthcare-healthcare" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-healthcare" + unique,
    xlinkHref: "#path-1-healthcare" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-healthcare" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.5,9.5 L20.5,9.5 C20.7761424,9.5 21,9.72385763 21,10 L21,14 C21,14.2761424 20.7761424,14.5 20.5,14.5 L14.5,14.5 L14.5,20.5 C14.5,20.7761424 14.2761424,21 14,21 L10,21 C9.72385763,21 9.5,20.7761424 9.5,20.5 L9.5,14.5 L3.5,14.5 C3.22385763,14.5 3,14.2761424 3,14 L3,10 C3,9.72385763 3.22385763,9.5 3.5,9.5 L9.5,9.5 L9.5,3.5 C9.5,3.22385763 9.72385763,3 10,3 L14,3 C14.2761424,3 14.5,3.22385763 14.5,3.5 L14.5,9.5 Z",
    fill: "inherit",
    id: "path-1-healthcare" + unique
  }))));
};

Healthcare.propTypes = propTypes;
var _default = Healthcare;
exports["default"] = _default;